export class WizardSettings {
    assetTrackingAccountId: number;
    playbooksCourseId: string;
    taskTrackerApiKey: string;
    perryWeatherIntegrationKey: string;
    spectrumApiKey: string;
    strikeGuardID: string;
    mayaApiToken: string;
    turfProApiToken: string;
}
